<template>
  <div>
    <div
      class="relative before:absolute before:right-0 before:-z-10 before:h-full before:w-full before:content-[''] lg:before:w-1/2 lg:before:bg-blue-lighter"
    >
      <div class="mx-auto flex flex-col lg:container lg:flex-row">
        <div class="mb-9 basis-1/2 px-4 lg:mb-0 lg:p-16">
          <SubTitle class="text-blue">{{ data?.subtitle }}</SubTitle>
          <Title :custom-style="twMerge('lg:max-w-[70%]', useDarkMode ? 'text-white' : '')">
            {{ data?.title }}
          </Title>
        </div>
        <div
          :class="
            twMerge(
              'basis-1/2 px-4 py-8 lg:p-16',
              useDarkMode ? 'bg-blue-darkest' : 'bg-blue-lighter',
            )
          "
        >
          <div class="max-w-2xl">
            <span
              :class="
                twMerge(
                  'font-sans text-base leading-normal lg:text-lg [&_strong]:text-lg lg:[&_strong]:text-xl',
                  useDarkMode ? 'text-white' : '',
                )
              "
              v-html="data?.copy"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <div class="relative aspect-[3/2] w-full lg:aspect-[2.56] xl:h-[550px]">
      <NuxtImg
        v-if="data?.image?.url"
        :src="data?.image?.url"
        :alt="data?.image?.alt"
        provider="cloudinary"
        class="absolute h-full w-full object-cover object-center 3xl:rounded-[1rem]"
        loading="lazy"
        sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw"
        fit="fill"
      />
    </div>
    <div class="container mx-auto">
      <div class="flex flex-col lg:flex-row">
        <div
          v-for="(item, index) in data?.cards"
          :key="index"
          class="basis-1/2 px-4 py-6 lg:p-16"
          :class="[index % 2 !== 0 && 'relative']"
        >
          <div
            v-if="index % 2 !== 0"
            class="absolute -left-10 top-0 mx-4 h-0.5 bg-blue-lighter lg:top-16 lg:h-4/6 lg:w-0.5"
          ></div>
          <Card :card="item" :index="index" :centered="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import Card from '../molecules/Card.vue'
import NuxtImg from '../atoms/NuxtImg.vue'
import type { ICardData, IImageData } from '../../types'
import { computed, inject } from 'vue'
import { twMerge } from 'tailwind-merge'

export interface IBigArgumentBlock {
  id: string
  subtitle?: string
  title?: string
  copy?: string
  image?: IImageData
  cards?: ICardData[]
}

interface Props {
  data: IBigArgumentBlock
}

defineProps<Props>()

const settings = inject<string[]>('settings', [])
const useDarkMode = computed(() => settings?.includes('dark_theme') ?? false)
</script>
